import styled from 'styled-components';

const Styled = styled.div`
  div.ant-checkbox-group {
    display: flex;
    ${(props) => props.vertical && 'flex-direction: column;'}
    ${(props) => props.width && `width: ${props.width}px;`}
    gap: 8px;

    > label.ant-checkbox-wrapper {
      width: 112px;
      height: 36px;
      flex-grow: 0;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      gap: 8px;
      padding: 10px 24px;
      border-radius: 6px;
      box-shadow: 0 2px 4px 0 rgba(96, 97, 112, 0.16), 0 0 1px 0 rgba(40, 41, 61, 0.04);
      border: solid 1px rgba(216, 216, 216, 0.01);
      background-color: #fff;
      ${(props) =>
        props.vertical ? 'border-bottom-width: 1;' : 'border-right-width: 1;'}

      > span:first-child {
        display: none;
      }
      > span:last-child {
        padding: 0;
      }
    }

    > label.ant-checkbox-wrapper-checked {
      border-radius: 6px;
      box-shadow: 0 2px 4px 0 rgba(96, 97, 112, 0.16), 0 0 1px 0 rgba(40, 41, 61, 0.04);
      border: solid 2px #00a483;
      background-color: #f5fbfa;
    }
    > label.ant-checkbox-wrapper-checked + label.ant-checkbox-wrapper {
      ${(props) =>
        props.vertical ? 'border-top-width: 1;' : 'border-left-width: 1;'}
    }

    > label.ant-checkbox-wrapper:last-child {
      ${(props) =>
        props.vertical
          ? 'border-bottom-width: 1px;'
          : 'border-right-width: 1px;'}
    }
  }
`;

export default Styled;
